import { useLang } from "@/i18n";

const STYLES = {
  EN_ATTENTE: "bg-sable/40 text-maquis-deep",
  VALIDEE: "bg-maquis-olive text-casse",
  REFUSEE: "bg-[#8C3B2E]/15 text-[#8C3B2E]",
  EN_COURS: "bg-mer text-casse",
  TERMINEE: "bg-mer-gris/25 text-mer",
};

export default function StatusBadge({ status }) {
  const { t } = useLang();
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-block rounded-full px-3 py-1 text-[11px] uppercase tracking-[0.12em] ${STYLES[status] || "bg-ivoire text-maquis-deep"}`}
    >
      {t.status[status] || status}
    </span>
  );
}
